import React from 'react';
import FAQBase from './FAQBase';

const questions = [
  {
    question: 'Do both parents need to choose the same guardian?',
    answer:
      "Parents are not required to name the same guardian. If their choices differ or are unclear, a court may evaluate the circumstances and decide what is in the child's best interests.",
  },
  {
    question: 'Does naming a guardian guarantee that person will be chosen?',
    answer:
      "A court makes the final guardianship decision based on the child's best interests, although your guardianship nomination will be one of the factors considered by the judge.",
  },
  {
    question: 'Can I name a guardian that is outside of the United States?',
    answer:
      'Parents may choose to name a guardian who lives outside of the United States. Whether that arrangement can work depends on practical factors such as immigration rules, travel logistics, and local law. A court may consider these factors before making a final decision.',
  },
  {
    question:
      'If someone named in my documents moves or changes their name after becoming married, do I need to update the information?',
    answer:
      "Minor changes, such as a new address or last name, do not always require document updates, but it's a good idea to review your plan periodically to make sure it still clearly identifies the intended person. You can come back to update your estate plan online as needed.",
  },
];

const GuardiansFAQ = () => <FAQBase questions={questions} />;

export default GuardiansFAQ;
